module.exports = {
  emptyMessage: 'من فضلك، قم بكتابة اسمك',
  defaultMessage: 'من فضلك، قم بكتابة اسمك',
};
